import { Directive, Input, OnChanges, TemplateRef, ViewContainerRef } from '@angular/core';
import { NetworkService } from '@damofire/data-angular-commons';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from '../auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Directive({
  selector: '[appIfOnline]',
  standalone: true,
})
export class IfOnlineDirective implements OnChanges {
  private readonly sub: Subscription;

  @Input()
  appIfOnline: boolean | string;

  constructor(
    private readonly templateRef: TemplateRef<any>,
    private readonly viewContainer: ViewContainerRef,
    private readonly networkService: NetworkService,
  ) {
    this.sub = networkService.status.subscribe(() => this.showOrHide());
  }

  ngOnChanges() {
    this.showOrHide();
  }

  private showOrHide() {
    this.viewContainer.clear();
    if (this.networkService.connected && this.appIfOnline !== false) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
